import Teaser from '../components/teaser'
import { loadRessort } from '../helper/externalApi'
import { RessortEntry } from '../helper/interfaces'
import React from 'react'
import { nextBasicAuthCheck } from '../helper/basicAuthHelper'
import Piano from '../components/Piano'
import TrackedRessortComponent from '../components/TrackedRessortComponent'
interface Data {
  entry: RessortEntry | null
  id: string
}

function Index(data: Data) {
  return <React.Fragment>
      <Piano article={undefined} showOffer={false} trackingInformation={data.entry?.pageInformation?.trackingInformation} pianoSwitchConfiguration={data.entry?.pageInformation?.pianoSwitchConfiguration}/>
      <TrackedRessortComponent entry={data.entry} id={data.id}/>
    </React.Fragment>
}


export async function getServerSideProps(context) {
  const { req, res } = context
  await nextBasicAuthCheck(req, res)

  let result: RessortEntry | null = await loadRessort(process.env.NEXT_PUBLIC_HOME_RESSORT ?? '');
  return { props: { entry: result, id: process.env.NEXT_PUBLIC_HOME_RESSORT } };
}

export default Index
